import enUS from './en-US'
import frCA from './fr-CA'
import zhCN from './zh-CN'

export default {
  'en-US': enUS,
  'fr-CA': frCA,
  'zh-CN': zhCN,
}
